(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/prolongation/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/lotto/components/prolongation/assets/javascripts/prescript.js'); 
'use strict';

svs.lotto = svs.lotto || {};
svs.lotto.components = svs.lotto.components || {};
svs.lotto.components.prolongation = svs.lotto.components.prolongation || {};
svs.lotto.components.prolongation.views = svs.lotto.components.prolongation.views || {};
 })(window);